module.exports = __webpack_public_path__ + "img/login_bg.c8dcda77.jpg";